import Error404 from '@/views/error-page/404.vue'
import Error401 from '@/views/error-page/401.vue'
import Error403 from '@/views/error-page/403.vue'

export default [
  {
    path: '/404',
    name: '404',
    component: Error404,
    hidden: true
  }, {
    path: '/403',
    name: '403',
    component: Error403,
    hidden: true
  },
  {
    path: '/401',
    name: '401',
    component: Error401,
    hidden: true
  }
]
